import { render } from "./ReplaceCategory.vue?vue&type=template&id=618d5f98"
import script from "./ReplaceCategory.vue?vue&type=script&lang=js"
export * from "./ReplaceCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__